import React from 'react';

import { VictoryChart, VictoryAxis, VictoryLine, VictoryLabel, VictoryVoronoiContainer, VictoryTooltip, VictoryLegend, VictoryTheme } from 'victory';

import moment from 'moment';

const BLUE_COLOR = "#00a3de";
const RED_COLOR = "#7c270b";

const styles = {
  axisX: {
    grid: { stroke: '#cccccc' },
    ticks: { strokeWidth: 1 },
    tickLabels: {
      fontFamily: "inherit",
      fontSize: 7
    }
  },

  axisY: {
    grid: { stroke: '#cccccc' },
    ticks: { strokeWidth: 1 },
    tickLabels: {
      fontFamily: "inherit",
      fontSize: 7
    }
  },

}

const RateChart = ({ data, title, className }) => {

  return (
    <div className={className}>
      <VictoryChart
        scale={{ x: "time", y: "linear" }}
        // animate={{ duration: 2000 }}
        style={{ parent: { backgroundColor: '#ffffff' } }}
        padding={{ top: 50, bottom: 20, left: 20, right: 50 }}
        containerComponent={
          <VictoryVoronoiContainer
            labels={({ datum }) => {

              const x = moment(datum.x).format('DD/MM/YYYY HH:mm')

              return `Data: ${x} \n Taxa de rendimento: ${datum.y}% a.a.`;
            }
            }
            labelComponent={<VictoryTooltip constrainToVisibleArea={true} cornerRadius={2} centerOffset={{ x: 5 }} flyoutHeight={30} flyoutStyle={{ stroke: "#cccccc", strokeWidth: 1 }} style={{ fill: "#276749" }} />}
          />
        }>

        <VictoryLabel text={title} x={225} y={30} textAnchor="middle" style={{ fontSize: '9' }} />

        <VictoryLegend x={20} y={20}
          style={{ 
              labels: {  fontSize: 7, fill: '#38A169'  },
              border: { stroke: "#38A169", strokeWidth: 1 },
          }}
          data={[
            { name: "Taxa de rendimento", symbol: { fill: "#276749" } },
          ]}
        />

        {/* <VictoryLabel x={25} y={24} text={title} /> */}

        <VictoryAxis crossAxis tickFormat={(x) => moment(x).format('DD/MM/YYYY')} style={styles.axisX} />

        <VictoryAxis dependentAxis crossAxis style={styles.axisY} />

        <VictoryLine data={data}
          style={{
            data: {
              stroke: "#2f855a",
              strokeWidth: 1,
              strokeLinecap: "round"
            },
            labels: { angle: -45, fontSize: 6 }
          }}
        >
        </VictoryLine>
      </VictoryChart>
    </div>
  );
}

export default RateChart;